import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { DecimalPipe, CurrencyPipe, PercentPipe } from '@angular/common';

@Pipe({
  name: 'customPipe'
})

//Aquí iremos implementando los distintos formatos usando los PIPES correspondientes
export class CustomPipe implements PipeTransform
{
    formato:String = "";
    format:String = "";
    valor:any = null;

    decimalPipe: DecimalPipe = new DecimalPipe("es-ES");
    currencyPipe: CurrencyPipe = new CurrencyPipe("es-ES");
    //percentPipe: PercentPipe = new PercentPipe("es-ES");

    transform(value: any, args?: any): any
    {
        this.formato = args;

        if (this.formato != undefined) //FRIGENTI-FALTA
        {

            this.format = this.formato.toLowerCase();

            switch (this.format)
            {
                //Formateo Fechas
                case ("dd/mm/yyyy"):
                case ("date: 'dd/mm/yyyy'"):
                case ("date: 'dd/mm/yyyy' "):
                case ("date:'dd/mm/yyyy'"):
                {
                    this.valor = moment(value).format('DD/MM/YYYY');
                    break;
                }

                //Formateo Precios con moneda "EUR" //FRIGENTI-FALTA-Comprobar los formateos en todas las filiales(por si cambia la moneda o el Nª de decimales...etc)
                case ("currency: 'eur'"):
                {
                    this.valor = this.currencyPipe.transform(value, 'EUR');
                    break;
                }

                //Formateo Cantidades: mínimo que salga un dígito y que muestre 2 decimales siempre
                case ("number: '.2-2'"):
                {
                    this.valor = this.decimalPipe.transform(value, '.2-2');
                    break;
                }

                //Formateo Porcentajes: mínimo que salga un dígito y que muestre 2 decimales siempre
                case ("percent: '1.2-2'"):
                {
                    this.valor = (this.decimalPipe.transform(value, '1.2-2') + '%');
                    break;
                }

                //Formateo Porcentajes: mínimo que salga un dígito y que muestre "máximo" 2 decimales(puede no mostrar decimales si el número fuese un entero)
                case ("percent: '1.0-2'"):
                {
                    this.valor = (this.decimalPipe.transform(value, '1.0-2') + '%');
                    break;
                }
                // check y x
                case ("boolean-icons"):
                {
                    if(value === true){
                        this.valor = '<span class="k-icon k-i-check text-size-big"></span>';

                    }else{
                        this.valor = '<span class="k-icon k-i-x text-size-big"></span>' ;
                    }
                    break;
                }
                // solo check, sin x
                case ("boolean-icons-only-check"):
                    {
                        if(value === true){
                            this.valor = '<span class="k-icon k-i-check text-size-big"></span>';

                        }else{
                            this.valor = '<span class="k-icon text-size-big"></span>';
                        }
                        break;
                    }
                //Sin formatear=>Pintamos el dato tal y como lo recibimos de base de datos
                default:
                {
                    this.valor = value;
                    break;
                }
            }

            return this.valor;
        }else return value;

    }
}
